// extracted by mini-css-extract-plugin
module.exports = {"md":"only screen and (min-width: 992px)","resultsContainer":"quick_price__resultsContainer__W9Whn"};